<template>
  <div  class="container-fluid">
    
    <div v-if="type=='A'" class="card">
           
            <confirmBoxModal v-if="cb" @hide="cb=false" @process="clickHandler(method)" v-bind:spinner="modalSpinner">

              <template v-slot:header>
                <h4>
                  <i class="fas fa-exclamation-circle mr-3" aria-hidden="true"></i>
                <strong>  {{ header }}</strong>
                </h4>     
              </template>
              
              <template v-slot:body>
                <h4><strong>{{body}}</strong></h4>
              </template>
              
            </confirmBoxModal>
  
        <div class="card-header text-white bg-primary">
          
          
            <h4 class="header">
              <i class="fas fa-business-time mr-2" aria-hidden="true"></i>
              PROMO SALDI</h4>
             <small id="Help" class="form-text text-muted"></small>
        </div>
        
      <div class="card-body">
     
         <button @click="type='B'"  type="button" class="btn btn-primary mb-2 mr-2">
                  <i class="fas fa-edit mr-2" aria-hidden="true"></i>
                  NUOVA PROMO</button>

      <edit-promo v-if="edit" @hide="edit=false" v-bind:promoId="promoId" ></edit-promo>    
      <div v-if="!spinner" class="table-wrapper-scroll-y my-custom-scrollbar">
      <table class="table table-hover table-sm table-bordered table-striped mb-0" id="table">
        
      <thead>
        <tr>

            
          <th></th>

          <th>#</th>
          
          
          <th>ATTIVA</th>
          <th>IINIZIO</th>
          <th>FINE</th>
          <th>DESCRIZIONE</th>
              
        </tr>
      </thead>
      <tbody>
      <tr 
      draggable="true"
        @dragstart='startDrag($event, item)' 
        @drop='onDrop($event, item)' 
        @dragover.prevent
        @dragenter.prevent
      @dblclick="openPromo(item)" class="pointer" v-for="(item,index) in filteredPromo" :key="index">
        <td>
          <i @click="editPromo(item.promoId)" style='color:#800080;' data-toggle="tooltip" title="modifica promo" class="fa fa-edit" aria-hidden="true"></i>
          </td>        
        <td>{{item.promoId}}</td>        
        <td> <span :class="{dotRed:item.active == 1}"></span></td>
        <td>{{item.start_at}}</td>
        <td>{{item.end_at}}</td>
        <td>{{item.description}}</td>
        
      </tr>
      </tbody>
      <tfoot>
        <tr>                  
        </tr>
      </tfoot>  
    </table>
  </div>
  <div v-else>
    <spinner v-bind:spinner="spinner"></spinner>
  </div>
  
  <div class="form-group mt-5">
  <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>
  <label for="cerca"><strong>Filtra</strong></label>
  <input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">
  </div>
  

  </div>

  <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  </div>

  <div v-else-if="type=='B'" >
    <new-promo @close="type='A',getPromoList()" />
  </div>  
  <div v-else-if="type=='C'" >
    <promo-items @close="type='A',getPromoList()" v-bind:promoId="promoId" />
  </div>  
  

  

  </div>
</template>

<script>
import { mapGetters }  from 'vuex';
import newPromo        from '@/components/frontOffice/NewPromo.vue'
import promoItems      from '@/components/frontOffice/Promo.vue'
import editPromo       from '@/components/frontOffice/EditPromo.vue'
import alertBox        from '@/components/common/AlertBox.vue';
import confirmBoxModal from '@/components/common/ConfirmBoxModal.vue';
import spinner         from '@/components/common/Spinner.vue';
import api             from '@/api'


  export default {

     components: {newPromo,promoItems,editPromo,alertBox,confirmBoxModal,spinner},
     //props : ['storeId'],
    data () {
      return {

        modalSpinner  : false,
        header        : '',
        body          : '',
        cb            : false,
        method        : '',
        items         : [],
        filterKey     : '',
        spinner       : false,
        type          : 'A',
        promoId       : 0,
     
        promoId1      : 0,
        promoId2      : 0,
        msg             : {
                title : '',
                body  : '',
                type  : 0      
        },
        edit          : false
        
      }
    },

      
    computed: {
   
       ...mapGetters(['company']),
       filteredPromo : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  
      
    },

    created () 
    {       
      this.getPromoList()
    },
    methods: 
    {

      clickHandler (method) 
      {
        this[method]()  
      },  

      startDrag (evt, item) {
        
      
       // this.msg.title = ''
        evt.dataTransfer.dropEffect = 'move'
        evt.dataTransfer.effectAllowed = 'move'
        evt.dataTransfer.setData('item_from', JSON.stringify(item))
      
      },
      onDrop (evt, item_to) {

      const item_from = JSON.parse(evt.dataTransfer.getData('item_from'))
      
        this.promoId1        = item_from.promoId
        this.promoId2        = item_to.promoId
        
        this.header          = 'UNIFICAZIONE DA ID PROMO ' + this.promoId1 + ' A ID PROMO ' + this.promoId2 
        this.body            = "PROCEDO ?"
        this.method          = 'updateDragDropPromo'
        this.cb              = true

      },


    editPromo(promoId)
     {
       this.promoId = promoId
       this.edit    = true
       
     },

     
      openPromo(item)
      {
        this.promoId = item.promoId
        this.type = 'C'
      },
      async updateDragDropPromo()
      {
        
        //console.log('updateDragDropPromo')

        this.modalSpinner = true
        const data  = {'promoId1'   : this.promoId1,'promoId2':this.promoId2}
        const sp    = {'sp'         : 'spUpdatePromoFromDragAndDrop'}
        const json  = Object.assign(data, sp);

        await api.post(json).then(res => {
        
          if(res.status==200)
            {
              
              this.msg.title = 'UNIFICAZIONE PROMO EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              this.getPromoList()   
              
            }
           else if(res.status==500)
           {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
                console.log(res.data)                             
           } 
           else
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1
                console.log('Network Error.')                  
                 
            } 
          
          }).catch(err => {
              
              console.log(err.message)   
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.cb = false  
          
          this.modalSpinner = false
        });      
      },

      async getPromoList()
      {
        
        this.spinner = true
        const data   = {'companyId' : this.company.Id}
        const sp     = {'sp'        : 'spPromoLIst'}
        const json   = Object.assign(data, sp);

        await api.post(json).then(res => {
          
          if(res.status==200)
            {
             this.items = res.data.recordsets[0] 
            }
           else if(res.status==500)
           {
                console.log(res.data)                             
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          
          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
          this.spinner = false
        });



      },
      
      

    }
  }
</script>

<style scoped>
  
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.my-custom-scrollbar {
    position  : relative;
    height    : 350px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
.header {
  font-family : 'Roboto Condensed';
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;

   
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;  

    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .fa-print:hover{

    color : red;
}
 .fa-print{

     color       : brown;

 }
 .dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color:darkgreen}
.card-header
{
  height: 45px;
}
</style>
